import { useState } from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { Tooltip } from "antd";

import Resources from "scripts/resources";
import Icons from "scripts/icons";
import API from "scripts/api";

const Component = ({
	address,
	bookmarked: defBookmarked,
	category,
	cover,
	discount,
	id,
	slug,
	title,
	user,
}) => {
	const [bookmarked, setBookmarked] = useState(defBookmarked);

	const bookmark = (id) => {
		API.job
			.bookmark(id)
			.then(({ bookmarked }) => {
				setBookmarked(bookmarked);
			})
			.catch(() => {});
	};

	return (
		<div className="spa-job-card">
			<Link
				to={`/job/${slug}`}
				className="cover"
			>
				<img
					src={cover?.url}
					alt={title}
				/>
			</Link>
			<h3 className="name">
				<Link to={`/job/${slug}`}>{title}</Link>
			</h3>
			<h5 className="category">
				<Link to={`/jobs?category=${category?.slug}`}>
					<img
						src={category?.icon}
						alt={category?.title}
					/>
					{category?.title}
				</Link>
			</h5>
			<span className="address">{address}</span>
			{user?.id ? (
				bookmarked ? (
					<Icons.Saved
						className="bookmark gray"
						onClick={() => bookmark(slug)}
					/>
				) : (
					<Icons.Save
						className="bookmark"
						onClick={() => bookmark(slug)}
					/>
				)
			) : (
				<Link to="/auth/status">
					<Tooltip title={Resources.saveCondition}>
						<Icons.Save className="bookmark" />
					</Tooltip>
				</Link>
			)}

			{Number(discount?.raw) > 0 && (
				<span className="discount">
					{discount.formatted}
					{Resources.discountPercent}
				</span>
			)}
		</div>
	);
};

export default connect((state) => {
	return {
		user: state.user,
	};
})(Component);
